import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

type Props = {
  title?: string;
  isNoIndex?: boolean;
};

const MetaSetting: React.FC<Props> = ({ title, isNoIndex }) => (
  <HelmetProvider>
    <Helmet>
      {title && <title>{title}</title>}
      {isNoIndex && <meta name='robots' content='noindex' />}
    </Helmet>
  </HelmetProvider>
);

MetaSetting.defaultProps = {
  title: undefined,
  isNoIndex: undefined,
};

export default MetaSetting;
